module.exports = "/images/img-usuario-perfil.svg?7d930f79f75024524cc200f2cb6d0b9b";